import { Either } from "@core/domain/types/either";
import { FallbackError } from "@core/domain/errors/fallback.error";
import { ValidationError } from "@core/domain/errors/validation.error";
import { BudgetTemplate } from "@project/domain/models/budget-template/budget-template";
import { CreateBudgetFromTemplate } from "@project/domain/models/budget-template/create-budget-from-template";
import { MarkAsTemplate } from "@project/domain/models/budget-template/mark-as-template";
import { FinancialEntityBudget } from "@project/domain/models/budget/financial-entity-budget.model";
import { injectable } from "inversify";

@injectable()
export abstract class BudgetTemplateRepositoryAbstract {
    abstract getAllTemplates(): Promise<Either<FallbackError, BudgetTemplate[]>>;
    abstract createBudgetFromTemplate(createBudgetFromTemplate: CreateBudgetFromTemplate): Promise<Either<ValidationError | FallbackError, FinancialEntityBudget>>;
    abstract markAsTemplate(markAsTemplate: MarkAsTemplate): Promise<Either<ValidationError | FallbackError, FinancialEntityBudget>>;
    abstract createTemplate(templateData: { name: string; description: string; is_template: boolean; finantial_entity: null }): Promise<Either<ValidationError | FallbackError, FinancialEntityBudget>>;
    abstract createTemplateFromTemplate(templateId: number, name: string, description: string): Promise<Either<ValidationError | FallbackError, FinancialEntityBudget>>;
}
